export const oppConstants = {
  OPP_CREATE_LOADING: 'OPP_CREATE_LOADING',
  OPP_CREATE_SUCCESS: 'OPP_CREATE_SUCCESS',
  OPP_CREATE_FAILURE: 'OPP_CREATE_FAILURE',
  OPP_ERROR_RELOAD: 'OPP_ERROR_RELOAD',

  OPP_LIST_LOADING: 'OPP_LIST_LOADING',
  OPP_LIST_SUCCESS: 'OPP_LIST_SUCCESS',
  OPP_LIST_FAILURE: 'OPP_LIST_FAILURE',
  OPP_LIST_CLEAR: 'OPP_LIST_CLEAR',

  OPP_EDIT_LOADING: 'OPP_EDIT_LOADING',
  OPP_EDIT_SUCCESS: 'OPP_EDIT_SUCCESS',
  OPP_EDIT_FAILURE: 'OPP_EDIT_FAILURE',

  OPP_DELETE_LOADING: 'OPP_DELETE_LOADING',
  OPP_DELETE_SUCCESS: 'OPP_DELETE_SUCCESS',
  OPP_DELETE_FAILURE: 'OPP_DELETE_FAILURE',


};
